import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import studioHomePlugin from '@internal/plugin-studio-home';
import studioWorkboardPlugin from '@internal/plugin-studio-workboard';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';

export default createApp({
  features: [catalogPlugin, navModule, studioHomePlugin, studioWorkboardPlugin, authModule],
});
